<template>
  <CCard class="contactTags pt-5">
    <CRow>
      <CCol sm="12">
        <header class="contactTags__header d-flex justify-content-between mb-2">
          <h3 class="contactTags__title font-weight-normal">{{ $t('audience.detailContact.tags') }}</h3>
          <div v-if="isCurrentOrganizationBase">
            <CButton v-if="!edit" @click="edit = true" color="primary" class="py-2 px-5">
              {{ $t('audience.detail.contactInformation.button.edit') }}
            </CButton>
            <CButton v-else @click="cancelEdit" color="gray-200" class="py-2 px-5">
              {{ $t('audience.detail.contactInformation.button.cancel') }}
            </CButton>
          </div>
        </header>
      </CCol>
      <CCol sm="12">
        <div class="contactTags__body p-0 pb-3 mt-4">
          <!-- recipient {{recipient}} -->
          <div v-if="loading" class="w-100 h-100 d-flex justify-content-center align-items-center">
            <CSpinner class="my-3" color="primary" />
          </div>
          <multiselect
            v-else
            :disabled="loading"
            v-model="tagsCopy"
            class="contactTags__select multiselect--tags"
            :class="{ 'multiselect--disabled': !edit }"
            tag-placeholder="Add this as new tag"
            placeholder="Search or add a tag"
            :options="optionTagsCopy"
            :multiple="true"
            :taggable="true"
            :show-labels="false"
            @tag="sendInfoTags($event, 'post', 'add')"
            @select="sendInfoTags($event, 'post', 'select')"
            @remove="sendInfoTags($event, 'delete')"
          ></multiselect>
          <!-- infos: {{infos}} -->
          <!-- infosCopy: {{infosCopy}} -->
        </div>
      </CCol>
      <CCol sm="12">
        <transition name="fade">
          <MenssageAlert :messages="messages" />
        </transition>
      </CCol>
    </CRow>
  </CCard>
</template>

<script>
import services from '@/services.js'
import MenssageAlert from '@/components/MenssageAlert'
import { mapGetters } from 'vuex'

export default {
  name: 'ContactTags',
  components: {
    MenssageAlert,
  },
  data() {
    return {
      tags: [],
      tagsCopy: [],
      optionTags: [],
      optionTagsCopy: [],
      edit: false,
      loading: false,
      recipient: [],
      messages: [],
      recipientId: null,
      isDelete: false,
    }
  },

  methods: {
    cancelEdit() {
      // this.tags = JSON.parse(JSON.stringify(this.tagsCopy));
      // this.optionTagsCopy = JSON.parse(JSON.stringify(this.optionTagsCopy));
      this.edit = false
      this.messages = []
    },

    updateTag(tag) {
      this.tagsCopy.push(tag)
    },

    //TODO REFACTORY
    sendInfoTags(tag, method, type) {
      this.messages = []
      this.loading = true
      services
        .recipientTags(this.$route.params.organizationId, this.$route.params.id, method, "'" + tag + "'")
        .then(() => {
          if (method == 'post' && type == 'add') {
            this.tagsCopy.push(tag)
            this.optionTagsCopy.push(tag)
            this.messages.push({
              status: 'success',
              text: `add tag ${tag}`,
            })

            return
          }

          if (method == 'post' && type == 'select') {
            this.messages.push({
              status: 'success',
              text: `add tag ${tag}`,
            })
            return
          }

          if (method == 'delete') {
            this.reloadSchema(tag)
          }
        })
        .catch((error) => {
          this.messages.push({
            status: 'danger',
            text: error.response.data.message,
          })
          this.optionTagsCopy = this.optionTags
          this.tagsCopy = this.tags
        })
        .finally(() => {
          this.loading = false
        })
    },

    reloadSchema(tag) {
      this.$store
        .dispatch('audience/getSchema', this.$route.params.organizationId)
        .then(() => {
          this.messages.push({
            status: 'success',
            text: `Delete tag ${tag}`,
          })
        })
        .catch((error) => {
          this.messages.push({
            status: 'danger',
            text: error.response.data.message,
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
  },

  computed: {
    ...mapGetters({
      isOrganizationBase: 'auth/isOrganizationBase',
    }),

    isCurrentOrganizationBase() {
      return this.isOrganizationBase(this.$route.params.organizationId)
    },

    schemaAudience() {
      if (this.$store.state.audience.schemaAudience) {
        return JSON.parse(JSON.stringify(this.$store.state.audience.schemaAudience))
      }
      return []
    },
    getterRecipient() {
      if (this.$store.state.audience.recipient) {
        return JSON.parse(JSON.stringify(this.$store.state.audience.recipient))
      }
      return []
    },
  },

  watch: {
    getterRecipient(newValues) {
      this.tags = newValues._MetaData.Tags
      this.tagsCopy = JSON.parse(JSON.stringify(newValues._MetaData.Tags))
    },

    schemaAudience(newValues) {
      this.optionTags = newValues.tags
      this.optionTagsCopy = JSON.parse(JSON.stringify(newValues.tags))
    },
  },
}
</script>

<style lang="scss">
.contactTags {
  background: none;
  border: none;
  box-shadow: none !important;

  &__select.multiselect--disabled {
    background: none;

    .multiselect__select {
      display: none;
    }
    .multiselect__tags {
      background: none;
      width: 90%;
    }
  }
}
</style>
